import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { FormRadioGroup } from 'components/form';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { EmailRecipients } from './EmailRecipients';
import { deskingSelectors } from '../../../../../model';
import { sendViaOptions } from '../../../../../constants';
import { FormSectionHeader } from '../../../../components';
import { DeskingTestIds } from '../../../../../constants';
import { FinanceProgramFormValues, FormSectionProps, SendVia as SendViaEnum } from '../../../../../types';
import { RenderWithCondition } from '../../../../../../../components/shared/Conditional/RenderWithCondition';

export const SendVia = ({ sectionName, ccEmailOptions }: FormSectionProps) => {
  const { control } = useFormContext<FinanceProgramFormValues>();

  const isSectionOpen = useSelector((state: any) => deskingSelectors.isSectionOpen(state, sectionName));
  const isSectionCollapsed = useSelector((state: any) => deskingSelectors.isSectionCollapsed(state, sectionName));

  const sendViaValue = useWatch({ control, name: 'sendVia.type' });

  const isShowEmailRecipients =
    (ccEmailOptions ?? []).length > 1 && [SendViaEnum.Email, SendViaEnum.TextAndEmail].includes(sendViaValue);

  return (
    <Box className="section" data-testid={DeskingTestIds.SendVia}>
      <FormSectionHeader
        name="Send Via"
        sectionName={sectionName}
        isSectionOpen={isSectionOpen}
        isSectionCollapsed={isSectionCollapsed}
      />

      <Box className="sectionFields">
        <Controller
          control={control}
          name="sendVia.type"
          render={({ field }) => <FormRadioGroup row options={sendViaOptions} {...field} />}
        />
        <RenderWithCondition condition={isShowEmailRecipients}>
          <EmailRecipients ccEmailOptions={ccEmailOptions!} />
        </RenderWithCondition>
      </Box>
    </Box>
  );
};
